import "./App.css";
import React, { useEffect, useState } from 'react';
import { IoSearchOutline } from "react-icons/io5";
import { TimeIntervalContext } from './context/TimeContext'
import LightWeightChart from "./pages/LightWeightChart";
import TwoMinuteLightWeightChart from "./pages/TwoMinuteLightWeightChart";
import FiveMinuteLightWeightChart from "./pages/FiveMinuteLightWeightChart"
import SymbolModals from "./component/Modals/SymbolModals";

const LightWeightCharting = () => {
  const [intervalTime, setIntervalTime] = useState(1)
  const [missingParams, setMissingParams] = useState(false);
  const [mode, setMode] = useState("dark")
  const [params] = useState(new URLSearchParams(window.location.search));
  const [symbolModal, setSymbolModal] = useState(false);

  useEffect(() => {
    const identifier = params.get("identifier")
    const symbol = params.get("symbol")
    const user_id = params.get("user_id")


    const requiredParams = ["symbol", "user_id", "identifier"];
    const missing = requiredParams.some(param => !params.get(param));
    setMissingParams(missing);


  }, [params])

  const renderComponent = () => {
    switch (intervalTime) {
      case 1:
        return <LightWeightChart timeState={intervalTime} />;
      case 2:
        return <TwoMinuteLightWeightChart />;
      case 5:
        return <FiveMinuteLightWeightChart />;
      default:
        return <LightWeightChart />;
    }
  };
  function OpenSymbolModal() {
    setSymbolModal(!symbolModal)
    return;
  }


  return (
    <>
      {missingParams ? (
        <div>Missing parameters</div>
      ) : (
        <div className="flex flex-col h-screen">
          <header className=" p-3 text-center" style={{ background: params.get("mode") == "dark" ? "#222" : "#ffffff" }}>
            <div className="flex space-x-2 ml-2">
              <button className={`flex items-center space-x-2 text-white  pr-4 py-1 ${params.get("mode")=="dark"? "hover:bg-gray-800":"hover:bg-slate-200"}`}>
                <IoSearchOutline className={`w-5 h-5 ${params.get("mode")=="dark"? "text-white":"text-black"}`} onClick={OpenSymbolModal} />
                <span className={`text-sm font-medium font-sans ${params.get("mode")=="dark"? "text-white":"text-black"}`}>
                  {params.get("symbol")}
                </span>
              </button>
              <div className="flex w-48 ml-2">
                <button className={`${params.get("mode")=="dark"? "text-white":"text-black"} hover:bg-primaryColor px-2 ${intervalTime == 1 ? "bg-primaryColor" : ""}`} onClick={() => setIntervalTime(1)} >1m</button>
                <button className={`${params.get("mode")=="dark"? "text-white":"text-black"} hover:bg-primaryColor px-2 ${intervalTime == 2 ? "bg-primaryColor" : ""} `} onClick={() => setIntervalTime(2)} >2m</button>
                <button className={`${params.get("mode")=="dark"? "text-white":"text-black"} hover:bg-primaryColor px-2 ${intervalTime == 5 ? "bg-primaryColor" : ""} `} onClick={() => setIntervalTime(5)} >5m</button>
              </div>
            </div>
          </header>
          {renderComponent()}
        </div>
      )}
      <SymbolModals boolData={symbolModal} Fun={OpenSymbolModal} />
    </>
  )
}

export default LightWeightCharting
